import { defineComponent } from 'vue'

import { pick } from '@xzx-design/utils'
import { useNamespace, useParent } from '@xzx-design/hooks'
import Checker from '@xzx-design/components/checkbox/src/checker.tsx'
import { RADIO_KEY } from './types'
import { radioProps } from './radio'

const name = 'XzxRadio'

export default defineComponent({
  name,
  __name: name,
  props: radioProps,

  emits: ['update:modelValue'],

  setup(props, { emit, slots }) {
    const ns = useNamespace('radio')

    const { parent } = useParent(RADIO_KEY)

    const checked = () => {
      const value = parent ? parent.props.modelValue : props.modelValue
      return value === props.name
    }

    const toggle = () => {
      if (parent) {
        parent.updateValue(props.name)
      } else {
        emit('update:modelValue', props.name)
      }
    }

    return () => (
      <Checker
        v-slots={pick(slots, ['default', 'icon'])}
        namespace={ns}
        role="radio"
        parent={parent}
        checked={checked()}
        onToggle={toggle}
        {...props}
      />
    )
  },
})
